import { render, staticRenderFns } from "./IntelliboardIcon.vue?vue&type=template&id=1ed89c9c&scoped=true&"
import script from "./IntelliboardIcon.vue?vue&type=script&lang=js&"
export * from "./IntelliboardIcon.vue?vue&type=script&lang=js&"
import style0 from "./IntelliboardIcon.vue?vue&type=style&index=0&id=1ed89c9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed89c9c",
  null
  
)

export default component.exports